<template>
  <div class='container-fluid'>
    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
        <div class='row no-gutters'>
          <div class='col'>
            <label for='oldestTraveller_dob'>{{$t('text.page3_input2b')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
          </div>
          <div class='col-auto'>
            <button v-if='this.$store.state.site==="cibc"' class="moreHelp"  @click="openTooltip($t('text.page3_input2_tooltip')+$t('text.contactSnippet'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input2b')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
            <button v-else href='javascript:void(0);' class="moreHelp" @click="openTooltip($t('text.page3_input2_tooltipnm')+$t('text.contactSnippetnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input2b')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
          <datepicker id='oldestTraveller_dob' 
              v-model='oldestTraveller_dob'
              initial-view="year" 
              :openDate="date30YearsAgo"
              :disabledDates="disabledBirthDates" 
              :typeable=true
              :language='datePickerLanguageLookup()'
              input-class='form-control' 
              :placeholder='$t("text.datePlaceholder")'
              format='M/d/yyyy'
              aria-required='true'></datepicker>
          <input style='display:none;' v-model='oldestTraveller' class='form-control' type='number' id='oldestTraveller' name="oldestTraveller" :placeholder="$t('text.page3_input2placeholder')" aria-describedby='err_oldestTraveller' aria-required='true'>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
          <span for='oldestTraveller_dob' class='feedback' id='err_oldestTraveller_dob' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
        <div class='row'>
          <div class='col'>
            <label v-if='oldestTraveller>59' id='lbl_numberOfTravellers' for='numberOfTravellers' v-html='$t("text.page3_input1b")'></label>
            <label v-else id='lbl_numberOfTravellers' for='numberOfTravellers' v-html='$t("text.page3_input1")'></label>
          </div>
          <div class='col-auto'>
            <button v-if="this.$store.state.site==='cibc'" class="moreHelp" @click="openTooltip($t('text.page3_input1_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input1')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
            <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input1_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input1')">
              <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
            </button>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <select v-model='numberOfTravellers' class='form-control' id='numberOfTravellers' aria-required="true">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
        <div class='row'>
          <div class='col'>
            <label v-if='this.$store.state.wantsCancellation===true' for='tripCost' >{{$t('text.page3_input5')}} <span class='requiredText' aria-hidden='true'>*</span></label>
            <label v-else for='tripCost' >{{$t('text.page3_input5')}} ({{$t('text.optional')}})</label>
          </div>
          <div class='col-auto'>
            <div v-if='this.$store.state.site==="cibc"'>
              <button v-if='this.$store.state.wantsCancellation===true' class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
              <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipoptional')+' '+$t('text.page3_input5_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
            </div>
            <div v-else>
              <button v-if='this.$store.state.wantsCancellation===true' class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
              <button v-else class="moreHelp" @click="openTooltip($t('text.page3_input5_tooltipoptional')+' '+$t('text.page3_input5_tooltipnm'))" :aria-label="$t('text.moreinformation') + $t('text.page3_input5')">
                <img src='../assets/images/helpIcon.png' style='margin-top:6px;' alt=""/>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <div class='input-group'>
          <div class='input-group-prepend'>
            <span class='input-group-text' style='width: 35px;'>$</span>
          </div>
          <input v-if='this.$store.state.wantsCancellation===true' v-model='tripCost' type="number" class='form-control' id='tripCost' placeholder="0" aria-required="true" aria-describedby='err_tripCost'/>
          <input v-else v-model='tripCost' type="number" class='form-control' id='tripCost' placeholder="0" aria-required="false" aria-describedby='err_tripCost'/>
        </div>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
        <span for='tripCost' class='feedback' id='err_tripCost' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
        <label for='province'>{{$t('text.page3_input6')}} <span class='requiredText' aria-hidden='true'>*</span></label>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <select v-model='province' class='form-control' id="province" name="province" aria-required="true" aria-describedby='err_province'>
          <option value="" disabled selected>{{$t("text.select")}}</option>
          <option :value='$t("text.prov1v")'>{{$t("text.prov1")}}</option>
          <option v-if='!(this.$store.state.site!=="cibc"&&showBC===false)' :value='$t("text.prov2v")'>{{$t("text.prov2")}}</option>
          <option :value='$t("text.prov3v")'>{{$t("text.prov3")}}</option>
          <option :value='$t("text.prov4v")'>{{$t("text.prov4")}}</option>
          <option :value='$t("text.prov5v")'>{{$t("text.prov5")}}</option>
          <option :value='$t("text.prov6v")'>{{$t("text.prov6")}}</option>
          <option :value='$t("text.prov7v")'>{{$t("text.prov7")}}</option>
          <option :value='$t("text.prov8v")'>{{$t("text.prov8")}}</option>
          <option v-if='!(this.$store.state.site!=="cibc"&&this.$i18n.locale==="fr")' :value='$t("text.prov9v")'>{{$t("text.prov9")}}</option>
          <option :value='$t("text.prov10v")'>{{$t("text.prov10")}}</option>
          <option v-if='!(this.$store.state.site!=="cibc"&&this.$i18n.locale==="en")' :value='$t("text.prov11v")'>{{$t("text.prov11")}}</option>
          <option :value='$t("text.prov12v")'>{{$t("text.prov12")}}</option>
          <option :value='$t("text.prov13v")'>{{$t("text.prov13")}}</option>
        </select> 
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
        <span for='province' class='feedback' id='err_province' tabindex="-1"></span>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
            <label for='departureDate'>{{$t('text.page3_input3')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <datepicker id='departureDate' 
          v-model='departureDate'
          :disabledDates="disabledTripDates" 
          :typeable=true
          input-class='form-control'
          :language='datePickerLanguageLookup()'
          :placeholder='$t("text.datePlaceholder")'
          format='MM/dd/yyyy'
          aria-required="true" ></datepicker>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
          <span for='departureDate' class='feedback' id='err_departureDate' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
            <label for='returnDate'>{{$t('text.page3_input4')}} <span class='requiredText' aria-hidden='true'>*</span><br/>{{$t('text.dateofbirthformat')}}</label>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <datepicker id='returnDate'
          v-model='returnDate'
          :disabledDates="disabledTripDates" 
          :typeable=true
          input-class='form-control'
          :language='datePickerLanguageLookup()'
          :placeholder='$t("text.datePlaceholder")'
          format='MM/dd/yyyy'
          aria-required="true" ></datepicker>
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
          <span for='returnDate' class='feedback' id='err_returnDate' tabindex="-1"></span>
      </div>
    </div>

    <div style='display:none;'>
      <input id='wantsCancellation' type='checkbox' v-model='wantsCancellation'>
    </div>
  </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import { addNavProceedCheck, updateNavProceed } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import { validateDepartureDate, validateReturnDate, validateOldestTraveller, validateTripCost } from "../utils/validation_custom.js";
import { validateBirthDate } from "../utils/validation_custom.js";
import bus from "../utils/bus.js";
import generalConfig from "../config/generalConfig.js";

import Datepicker from "vuejs-datepicker";
import {en, fr} from "vuejs-datepicker/dist/locale";
const date30YearsAgo = new Date();
date30YearsAgo.setDate(date30YearsAgo.getDate() - (365*30));
const date15DaysAgo = new Date();
date15DaysAgo.setDate(date15DaysAgo.getDate() - 15);

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      disabledTripDates: {
        to: this.$moment().add(-1, "days").toDate()
      },
      disabledBirthDates: {
        from: date15DaysAgo
      },
      date30YearsAgo,
    };
  },
  computed: {
    showBC: {
      get() {
        const gc = generalConfig();
        // alert(gc.showBCAfter);
        return this.$moment().isSameOrAfter(gc.showBCAfter);
      }
    },
    oldestTraveller_dob: {
      get() {
        return this.$store.state.oldestTraveller_dob;
      },
      set(newValue) {
        this.setDateOfBirth("oldestTraveller_dob", newValue);
        this.$nextTick( () => {
          updateNavProceed(document.getElementById("oldestTraveller_dob").targets);
        });
      }
    },
    numberOfTravellers: {
      get() {
        return this.$store.state.numberOfTravellers;
      },
      set(newValue){
      }
    },
    oldestTraveller: {
      get() {
        return this.$store.state.oldestTraveller;
      },
      set(newValue) {
        if (validateField(document.getElementById("oldestTraveller"), newValue, validationRules())){
          validateOldestTraveller(newValue, this.$store.state.wantsMedical, this.$store.state.site);
        }
      }
    },
    departureDate: {
      get() {
        return this.$store.state.departureDate;
      },
      set(newValue) {
        document.getElementById("departureDate").classList.add("is-valid");
        document.getElementById("departureDate").classList.remove("is-invalid");
        if (validateField(document.getElementById("departureDate"), newValue, validationRules())) {
          if(validateDepartureDate(new Date(newValue))===true){
            this.calculateOldestTraveller(document.getElementById("oldestTraveller_dob").value, newValue);
          }
          else {
            this.calculateOldestTraveller(document.getElementById("oldestTraveller_dob").value, this.$moment().format("MM/DD/YYYY"));
          }
          if(document.getElementById("returnDate").value!==""){
            validateReturnDate(
              new Date(document.getElementById("returnDate").value),
              new Date(newValue)
            );
          }
        }
          
        this.$nextTick(() => {
          updateNavProceed(document.getElementById("oldestTraveller_dob").targets);
        });
      }
    },
    returnDate: {
      get() {
        return this.$store.state.returnDate;
      },
      set(newValue) {
        document.getElementById("returnDate").classList.add("is-valid");
        document.getElementById("returnDate").classList.remove("is-invalid");
        if (validateField(document.getElementById("returnDate"), newValue, validationRules())) {
          validateReturnDate(newValue);
          validateDepartureDate(
            new Date(document.getElementById("departureDate").value),
            new Date(newValue)
          );
        }
        this.$nextTick( () => {
          updateNavProceed(document.getElementById("oldestTraveller_dob").targets);
        });
      }
    },
    tripCost: {
      get() {
        return this.$store.state.tripCost;
      },
      set(newValue) {
        if (validateField(document.getElementById("tripCost"), newValue, validationRules())){
          validateTripCost(this.$store.state.site,newValue);
        }
      }
    },
    province: {
      get() {
        return this.$store.state.province;
      },
      set(newValue) {
        validateField(document.getElementById("province"), newValue, validationRules());
        if(document.getElementById("departureDate").value!==""&&document.getElementById("returnDate").value!==""){
          validateReturnDate();
        }
      }
    },
    wantsCancellation: {
      get() {
        return this.$store.state.wantsCancellation;
      }
    }
  },
  methods:{
    datePickerLanguageLookup() {
        const locale = getLocale();
        if(locale==="fr") {
          return fr;
        }
        else {
          return en;
        }
    },
    openTooltip(text) {
      document.getElementById("keywordBody").innerHTML=text;
      this.$nextTick((targets)=>{
        document.getElementById("keywordBody").focus();
      });
      bus.$emit("openModal");
    },
    setDateOfBirth(targetField, newValue) {
      // Check if this is a valid Birth Date
      document.getElementById(targetField).classList.remove("is-invalid");
      document.getElementById(targetField).classList.add("is-valid");
      if (validateField(document.getElementById(targetField), newValue, validationRules())) {
        validateBirthDate(document.getElementById(targetField), newValue, this.$store.state.wantsMedical);
      }
      this.calculateOldestTraveller(newValue, document.getElementById("departureDate").value);
    },
    calculateOldestTraveller(oldestTravellerDoB, departureDate){
      let oldestTraveller = 0;
      let calculationDate=this.$moment().format("MM/DD/YYYY");
      if(!isNaN(this.$moment(departureDate,"MM/DD/YYYY"))){
        calculationDate=this.$moment(departureDate,"MM/DD/YYYY").format("MM/DD/YYYY");
      }
      const age = this.$moment(calculationDate,"MM/DD/YYYY").diff(this.$moment(oldestTravellerDoB,"MM/DD/YYYY"), "years", false);
      if(age>oldestTraveller) {
        oldestTraveller=age;
      }
      else {
        oldestTraveller = this.$moment().diff(this.$moment(document.getElementById("oldestTraveller_dob").value,"MM/DD/YYYY"), "years", false);
      }
      if (validateField(document.getElementById("oldestTraveller"), oldestTravellerDoB, validationRules())){
        validateOldestTraveller(oldestTraveller, this.$store.state.wantsMedical, this.$store.state.site);
      }
      document.getElementById("oldestTraveller").value=oldestTraveller;
    },
  },
  mounted() {
    // Clear appended text from Quote page title;
    document.getElementById("stepTitleAppend").innerHTML="";

    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}
    
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Ensure custom validaton runs when page opens.
    validateOldestTraveller(this.$store.state.oldestTraveller, this.$store.state.wantsMedical, this.$store.state.site);
    if(document.getElementById("tripCost").value>"0") {
      validateTripCost(this.$store.state.site);
    }
    if(document.getElementById("departureDate").value!==""&&document.getElementById("returnDate").value!==""){
      validateDepartureDate();
      validateReturnDate();
    }

    // Manually add ARIA tags for date time inputs
    document.getElementById("oldestTraveller_dob").setAttribute("aria-required","true");
    document.getElementById("departureDate").setAttribute("aria-required","true");
    document.getElementById("returnDate").setAttribute("aria-required","true");
    document.getElementById("departureDate").setAttribute("aria-describedby","err_departureDate");
    document.getElementById("returnDate").setAttribute("aria-describedby","err_returnDate");
    document.getElementById("oldestTraveller_dob").setAttribute("aria-describedby","err_oldestTraveller_dob");

    // IE Polyfill - I'm not sure why I added this originally? Might be obsolete.
    if (typeof Object.assign !== "function") {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
          "use strict";
          if (target == null) { // TypeError if undefined or null
            throw new TypeError("Cannot convert undefined or null to object");
          }
          const to = Object(target);
          for (let index = 1; index < arguments.length; index++) {
            const nextSource = arguments[index];

            if (nextSource !== null) { // Skip over if undefined or null
              for (const nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
          return to;
        },
        writable: true,
        configurable: true
      });
    }
    // Have fields begin validation on Blur, instead of when navigating to next page.
    callValidationStatusOnBlur(validationRules());

    // Check if Next button should be enabled or disabled.
    const targets = [
      document.getElementById("oldestTraveller_dob"),
      document.getElementById("departureDate"),
      document.getElementById("returnDate"),
      document.getElementById("province"),
    ];
    this.$nextTick( () => {
      addNavProceedCheck(targets);
    });
  }
};
</script>